<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="xl:col-6 col-12">
      <p-card>
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Статус</label>
            <crm-single-select
              [options]="statuses | sortTaskStatusByOrder"
              [(selectedItem)]="taskTemplate.status"
              sort="order:number"
              [filter]="false"
              [styleClass]="errors?.status ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.status ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.status"
              class="p-error">
              {{ errors.status | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Тип заявки</label>
            <crm-single-select
              [options]="kinds"
              [(selectedItem)]="taskTemplate.kind"
              optionValue="name"
              class="w-full {{ errors?.kind ? 'ng-invalid ng-dirty' : '' }}"
              [styleClass]="errors?.kind ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              [showClear]="true"
              (selectedItemChange)="changeKind()"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-kind="item">
                {{ kind.value | taskKindName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.kind"
              class="p-error">
              {{ errors.kind | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="taskTemplate.name"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [(ngModel)]="taskTemplate.disabled"
              [binary]="true"
              inputId="disabled"></p-checkbox>
            <label [for]="'disabled'">Неактивный</label>
          </div>
        </div>
      </p-card>

      <p-card
        header="Контрагент"
        styleClass="mt-3">
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="taskTemplate.contragent"
              (selectedContragentChange)="onContragentChange($event)"
              [customSearch]="false"
              appendTo="body"></crm-contragent-auto-complete>
          </div>
        </div>

        <div
          *ngIf="taskTemplate.contragent"
          class="field lg:col-6 col-12">
          <label class="font-medium required-field">Расчетный счет Контрагента</label>
          <crm-bank-details-single-select
            [bankDetails]="contragentBankDetails"
            [(selectedBankDetail)]="taskTemplate.contragentBankDetails"
            [isError]="$any(errors?.contragentBankDetails)"
            [customRequest]="true"
            appendTo="body"></crm-bank-details-single-select>
          <small
            *ngIf="errors?.contragentBankDetails"
            class="p-error">
            {{ errors.contragentBankDetails | join }}
          </small>
        </div>
      </p-card>

      <p-card
        header="Плательщик"
        styleClass="mt-3">
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Плательщик</label>
            <crm-company-single-select
              [(selectedCompany)]="taskTemplate.organization"
              (selectedCompanyChange)="changeOrganization($event)"
              [styleClass]="errors?.organization ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.organization ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-company-single-select>
            <small
              *ngIf="errors?.organization"
              class="p-error">
              {{ errors.organization | join }}
            </small>
          </div>

          <div
            *ngIf="taskTemplate.organization"
            class="field lg:col-6 col-12">
            <label class="font-medium required-field">Расчетный счет Плательщика</label>
            <crm-bank-details-single-select
              [bankDetails]="bankDetails"
              [(selectedBankDetail)]="taskTemplate.organizationBankDetails"
              [isError]="$any(errors?.organizationBankDetails)"
              [customRequest]="true"
              appendTo="body"></crm-bank-details-single-select>
            <small
              *ngIf="errors?.organizationBankDetails"
              class="p-error">
              {{ errors.organizationBankDetails | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label
              class="font-medium"
              [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
              Филиал
            </label>
            <crm-filial-single-select
              [filials]="filials"
              [(selectedFilial)]="taskTemplate.filial"
              [isError]="$any(errors?.filial)"
              [customRequest]="true"
              appendTo="body"></crm-filial-single-select>
            <small
              *ngIf="errors?.filial"
              class="p-error">
              {{ errors.filial | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label
              class="font-medium"
              [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
              Бизнес единица
            </label>
            <crm-unit-single-select
              [(selectedUnit)]="taskTemplate.unit"
              [isError]="$any(errors?.unit)"
              appendTo="body"></crm-unit-single-select>
            <small
              *ngIf="errors?.unit"
              class="p-error">
              {{ errors.unit | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label
              class="font-medium"
              [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.directionsRequired">
              Бюджетная статья
            </label>
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="taskTemplate.direction"
              [groupsDisabled]="true"
              [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-direction-single-select>
            <small
              *ngIf="errors?.direction"
              class="p-error">
              {{ errors.direction | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card
        header="Детали платежа"
        styleClass="mt-3">
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Назначение</label>
            <crm-template-subject-input
              [(subject)]="taskTemplate.subject"
              class="w-full"></crm-template-subject-input>
            <small
              *ngIf="errors?.subject"
              class="p-error">
              {{ errors.subject | join }}
            </small>
          </div>

          @if ([TaskKindEnum.PAYMENT_TO_SELF_EMPLOYED, TaskKindEnum.PAYMENT_TO_SUPPLIER].includes(taskTemplate.kind)) {
            <div class="field col-12">
              <label class="font-medium">Идентификатор платежа</label>
              <crm-input-text
                [(value)]="taskTemplate.paymentId"
                class="w-full"
                [isError]="$any(errors?.paymentId)"></crm-input-text>
              <small
                *ngIf="errors?.paymentId"
                class="p-error">
                {{ errors.paymentId | join }}
              </small>
            </div>
          }

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Тип платежа</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="taskTemplate.type"
              [isTemplateCombined]="true"
              [filter]="false"
              [class]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | paymentType }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Приоритет</label>
            <crm-single-select
              [options]="priorities"
              [(selectedItem)]="taskTemplate.priority"
              [filter]="false"
              [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.priority"
              class="p-error">
              {{ errors.priority | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Сумма</label>
            <p-inputNumber
              [(ngModel)]="taskTemplate.amount"
              [inputStyle]="{ width: '100%' }"
              [class]="errors?.amount ? 'ng-invalid ng-dirty' : ''"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              (onInput)="changeAmount($event.value)"
              styleClass="w-full"
              class="w-full"></p-inputNumber>
            <div
              *ngIf="taskTemplate.currency && taskTemplate.currency?.isoCharacter !== 'RUB' && taskTemplate.amount"
              class="text-medium text-lg uppercase mt-2">
              Сумма:
              {{
                (taskTemplate.amount || 0) * (taskTemplate.currency?.latestRate?.rate || 1)
                  | currency: 'RUB' : 'symbol' : '1.2-2'
              }}
            </div>
            <small
              *ngIf="errors?.amount"
              class="p-error">
              {{ errors.amount | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Валюта</label>
            <crm-currency-single-select
              *ngIf="!taskTemplate.organization; else customSearch"
              [(selectedCurrency)]="taskTemplate.currency"
              [showClear]="false"
              [isError]="$any(errors?.currency)"
              appendTo="body"></crm-currency-single-select>
            <ng-template #customSearch>
              <crm-currency-single-select
                [currencies]="currencies"
                [(selectedCurrency)]="taskTemplate.currency"
                [customSearch]="true"
                [showClear]="false"
                [isError]="$any(errors?.currency)"
                appendTo="body"></crm-currency-single-select>
            </ng-template>

            <small
              *ngIf="errors?.currency"
              class="p-error">
              {{ errors.currency | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">НДС</label>
            <crm-single-select
              [options]="nds"
              [(selectedItem)]="taskTemplate.nds"
              [filter]="false"
              [class]="errors?.nds ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.nds"
              class="p-error">
              {{ errors.nds | join }}
            </small>
          </div>

          <div
            *ngIf="accessRights.canReadDeal"
            class="field lg:col-6 col-12">
            <label class="font-medium">Сделка</label>
            <crm-deal-auto-complete
              [(selectedDeal)]="taskTemplate.deal"
              [isError]="$any(errors?.deal)"
              [showClear]="true"
              styleClass="w-full"
              inputStyleClass="w-full"
              appendTo="body"></crm-deal-auto-complete>
            <small
              *ngIf="errors?.deal"
              class="p-error">
              {{ errors.deal | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Центр затрат</label>
            <crm-cost-center-single-select
              [(selectedCostCenter)]="taskTemplate.costCenter"
              [isError]="$any(errors?.costCenter)"
              appendTo="body"></crm-cost-center-single-select>
            <small
              *ngIf="errors?.costCenter"
              class="p-error">
              {{ errors.costCenter | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Действует до</label>
            <crm-datepicker
              [(value)]="taskTemplate.activeUntil"
              (valueChange)="taskTemplate.disabled = false"
              [inputStyleClass]="errors?.activeUntil ? 'ng-invalid ng-dirty' : ''"
              [minDate]="today"
              appendTo="body"
              styleClass="w-full"></crm-datepicker>
            <small
              *ngIf="errors?.activeUntil"
              class="p-error">
              {{ errors.activeUntil | join }}
            </small>
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [(ngModel)]="taskTemplate.creditPayment"
              [binary]="true"
              inputId="creditPayment"></p-checkbox>
            <label [for]="'creditPayment'">Оплата через кредитные средства</label>
          </div>

          <div class="field col-12">
            <h3 class="font-medium -mb-2">Планирование дедлайна</h3>
            <p-divider></p-divider>
            <crm-planning-deadline-form
              [planning]="taskTemplate.deadline"
              [errors]="$any(errors?.deadline)"
              appendTo="body"></crm-planning-deadline-form>
          </div>
        </div>
      </p-card>

      <div class="mt-3">
        <crm-planning-periodicity-card
          [planning]="taskTemplate.planning"
          [errors]="$any(errors?.planning)"
          appendTo="body"></crm-planning-periodicity-card>
      </div>
    </div>
    <div class="xl:col-6 col-12">
      <p-card
        *ngIf="(form$ | async)?.isEdit && accessRights.canReadBrsTask"
        header="Созданные заявки на платеж"
        styleClass="mb-3">
        <ng-container *ngIf="!loadingTasks && tasks?.length">
          <div class="max-h-29rem overflow-y-auto overflow-x-hidden">
            <crm-table
              [columns]="taskColumns"
              [values]="tasks">
              <ng-template
                #rowTemplate
                let-task="item">
                <ng-container *ngIf="toTask(task) as task">
                  <tr>
                    <td>
                      <a
                        class="white-space-nowrap"
                        routerLink="/payments/task/card/{{ brsPrefixService.getPrefixedNumber(task) }}"
                        target="_blank">
                        {{ brsPrefixService.getPrefixedNumber(task) }}
                      </a>
                    </td>
                    <td>
                      {{ task.created | date: 'dd.MM.yyyy' }}
                    </td>
                  </tr>
                </ng-container>
              </ng-template>
            </crm-table>
          </div>

          <a
            label="в реестр"
            class="p-button-round p-button-text p-button-sm p-button-info cursor-pointer"
            icon="pi pi-external-link"
            (click)="directToTaskList()"></a>
        </ng-container>

        <ng-container *ngIf="!loadingTasks && !tasks?.length">
          <p class="text-xl font-medium">Нет заявок на платеж</p>
        </ng-container>

        <crm-spinner *ngIf="loadingTasks"></crm-spinner>
      </p-card>

      <p-card
        header="Согласователи"
        styleClass="mb-3">
        <div class="field">
          <label class="font-medium required-field">Схема согласования</label>
          <crm-approval-scheme-single-select
            [approvalSchemas]="schemes"
            [(selectedApprovalScheme)]="taskTemplate.scheme"
            (selectedApprovalSchemeChange)="changeUsersAndGroups($event)"
            [isError]="$any(errors?.scheme)"
            [customRequest]="true"
            appendTo="body"></crm-approval-scheme-single-select>
          <small
            *ngIf="errors?.scheme"
            class="p-error">
            {{ errors.scheme | join }}
          </small>
        </div>

        <ng-container *ngIf="taskTemplate.scheme">
          <div *ngFor="let user of taskTemplate.scheme.users; let index = index">
            <div class="flex align-items-center gap-1">
              <p>{{ index + 1 }}.</p>
              <crm-user-card-preview
                [user]="user"
                class="p-2"></crm-user-card-preview>
            </div>
          </div>
        </ng-container>
      </p-card>

      <p-card
        header="Участники"
        styleClass="mb-3">
        <div class="field">
          <label class="font-medium">Ответственный</label>
          <crm-user-single-select
            [(selectedUser)]="taskTemplate.responsible"
            [showClear]="true"
            appendTo="body"></crm-user-single-select>
        </div>

        <h3 class="font-medium -mb-2">Аудиторы</h3>
        <p-divider></p-divider>

        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="taskTemplate.userAuditors"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Группы</label>
            <crm-user-group-multi-select
              [(selectedUserGroups)]="taskTemplate.userGroupAuditors"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-group-multi-select>
          </div>
        </div>
      </p-card>

      <p-card
        *ngIf="taskTemplate.kind === TaskKindEnum.PAYMENT_OF_TAXES"
        header="Реквизиты платежа"
        styleClass="mb-3">
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">КБК</label>
            <crm-budget-classification-code-single-select
              [(selectedBudgetCode)]="taskTemplate.budgetClassificactionCode"
              appendTo="body"
              [isError]="$any(errors?.budgetClassificactionCode)"></crm-budget-classification-code-single-select>
            <small
              *ngIf="errors?.budgetClassificactionCode"
              class="p-error"
              >{{ errors.budgetClassificactionCode | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Код ОКТМО</label>
            <crm-input-text
              [(value)]="taskTemplate.municipalityClassificationCode"
              [isError]="$any(errors?.municipalityClassificationCode)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.municipalityClassificationCode"
              class="p-error"
              >{{ errors.municipalityClassificationCode | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Статус плательщика</label>
            <crm-payer-status-single-select
              [(selectedPayerStatus)]="taskTemplate.payerStatus"
              appendTo="body"
              [isError]="$any(errors?.payerStatus)"></crm-payer-status-single-select>
            <small
              *ngIf="errors?.payerStatus"
              class="p-error">
              {{ errors.payerStatus | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">УИН</label>
            <crm-input-text
              [(value)]="taskTemplate.uniqueAccrualIdentifier"
              [isError]="$any(errors?.uniqueAccrualIdentifier)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.uniqueAccrualIdentifier"
              class="p-error"
              >{{ errors.uniqueAccrualIdentifier | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Основание платежа</label>
            <crm-input-text
              [(value)]="taskTemplate.paymentReason"
              [isError]="$any(errors?.paymentReason)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.paymentReason"
              class="p-error"
              >{{ errors.paymentReason | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Налоговый период</label>
            <crm-input-text
              [(value)]="taskTemplate.taxPeriod"
              [isError]="$any(errors?.taxPeriod)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.taxPeriod"
              class="p-error"
              >{{ errors.taxPeriod | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Номер документа</label>
            <crm-input-text
              [(value)]="taskTemplate.documentNumber"
              [isError]="$any(errors?.documentNumber)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.documentNumber"
              class="p-error"
              >{{ errors.documentNumber | join }}</small
            >
          </div>

          <div class="field col-12">
            <h3 class="font-medium -mb-2">Планирование даты документа</h3>
            <p-divider></p-divider>
            <crm-planning-deadline-form
              [planning]="taskTemplate.documentDate"
              [errors]="$any(errors?.documentDate)"
              appendTo="body"></crm-planning-deadline-form>
          </div>
        </div>
      </p-card>

      <crm-task-template-history-widget
        *ngIf="(form$ | async)?.isEdit"
        [templateId]="taskTemplate['id']"
        class="block"></crm-task-template-history-widget>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="grid mt-3">
    <div class="xl:col-6 col-12 flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTemplate()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteTemplate()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
